@if (intermediateResult) {
  <div class="intresult">
    <div class="row mb-2">
      <div class="ir-detail-panel">
        <div class="number-panel">
          <div>
            <span class="btn bg-indigo-300 rounded-round btn-icon btn-sm legitRipple mr-3"><span
            class="letter-icon">{{irIndex + 1}}</span></span>
          </div>
        </div>
        <div class="left-panel">
          <div class="title">
            <div class="hub-unique-id-panel">
              <span class="hub-unique-id">{{intermediateResult.uniqueId}}</span>
            </div>
            <h5 class="text-indigo">
              <span class="font-weight-bold">
                Intermediate Result -
              </span> {{intermediateResult.indicatorName}} <span
            class="text-muted font-size-sm">({{intermediateResult.unit}})</span>
            @if (intermediateResult.hasLeveragedIntermediateResult) {
              <div class="intermediate-leverage">
                Leverage Indicator: <span
              class="text-muted font-size-sm">{{intermediateResultLeverage}}</span></div>
            }
          </h5>
        </div>
        @if (intermediateResult.isKeyResult) {
          <div
            class="badge badge-flat border-primary text-primary-600 mb-1">
            Key Result
          </div>
        }
        <p class="record-description">{{intermediateResult.statement}}</p>
        @if (intermediateResult.parentIntermediateResultProjectName) {
          <div class="font-size-lg text-indigo-300"
            >
            <i class="align-baseline mr-1 icon-tree7"></i>
            <span class="font-weight-bold">Linked to: </span>
            <span>Strategy Intermediate Result </span>
            <span class="font-weight-bold">{{intermediateResult.parentIntermediateResult.uniqueId}} </span>
            <span>{{intermediateResult.parentIntermediateResultProjectName}}</span>
          </div>
        }
      </div>
      <div class="right-panel">
        <div>
          @if (intermediateResult.irStatistics.hasTargets || intermediateResult.irStatistics.hasProgress) {
            <div
              class="d-flex flex-nowrap mt-2 pr-4" style="justify-content: flex-start;">
              <mat-checkbox [(ngModel)]="areDetailsShowing" color="primary">Show Details
              </mat-checkbox>
            </div>
          }
          <!-- PROGRESS BAR -->
          @if (!(isStrategy && intermediateResult.scaleMeasureDefinitions.length)) {
            <div>
              @if (intermediateResult.irStatistics.hasTargets) {
                <div>
                  <div class="progress mt-1 mb-2" style="height: 0.5rem;">
                    <div class="progress-bar bg-success"
                      [style.width.%]="intermediateResult.irStatistics.totalProgressPercent * 100">
                    </div>
                  </div>
                  @if (intermediateResult.irStatistics.lastTargetValue !== 0) {
                    <div>
                      <span class="font-weight-bold">
                      {{intermediateResult.irStatistics.totalProgressPercent | percent}}</span> achieved
                      towards target of
                      <span class="font-weight-bold">{{intermediateResult.irStatistics.lastTargetValue |
                        number: '0.0-0'}}
                      {{intermediateResult.unit}}</span>
                    </div>
                  }
                </div>
              }
              <div style="margin-top: 10px;" [innerHtml]="getCurrentPeriodProgressInfo(intermediateResult)">
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <!-- IR Details -->
  @if (areDetailsShowing) {
    <div class="row pl-5 pr-3" #detailsPanel>
      @if (!detailsLoading) {
        <div class="col-md-12">
          <h5 class="text-success">Intermediate Result Start, Progress and Target Values</h5>
          <div class="table-responsive mb-2 mr-3">
            <table class="table table-bordered table-border-dashed metric-table">
              <thead>
                <tr class="table-border-double">
                  <th class="text-right" width="5%">ID</th>
                  <th width="20%" class="text-right">Value Type</th>
                  <th width="30%" class="text-right">Date</th>
                  <th class="text-right">Value</th>
                </tr>
              </thead>
              <tbody>
                @for (target of intermediateResult.targets; track target) {
                  <tr>
                    <td class="text-right">
                      <div class="hub-unique-id-panel">
                        <span class="hub-unique-id">{{target.uniqueId}}</span>
                      </div>
                    </td>
                    <td class="text-right">
                      <span class="date-label text-success">Target</span>
                    </td>
                    <td class="text-right">
                      <span class="d-block">
                        {{target?.targetDate | date}}
                      </span>
                    </td>
                    <td class="text-right">
                      <div>
                        @if (intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{getScaleLabel(target?.targetValue)}}
                          </span>
                        }
                        @if (!intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{target?.targetValue | number:'':'en-US'}}
                          </span>
                        }
                        <span class="unit">
                          {{intermediateResult.unit}}
                        </span>
                      </div>
                      @if (intermediateResult.scaleMeasureDefinitions.length) {
                        <div>
                          {{getScaleDescription(target?.targetValue)}}
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
              @for (progress of cummulativeProgress; track progress) {
                <tbody>
                  @if (!progress.isStart) {
                    <tr>
                      <td class="text-right">
                        <div class="hub-unique-id-panel">
                          <span class="hub-unique-id">{{progress.uniqueId}}</span>
                        </div>
                      </td>
                      <td class="text-right">
                        <span class="date-label text-dark">Progress</span>
                      </td>
                      <td class="text-right">
                        <span class="d-block">
                          {{progress?.progressDate | date}}
                        </span>
                      </td>
                      <td class="text-right">
                        @if (intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{getScaleLabel(progress?.progressValue)}}
                          </span>
                        }
                        @if (!intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{progress?.progressValue | number:'':'en-US'}}
                          </span>
                        }
                        <span class="unit">
                          {{intermediateResult.unit}}
                        </span>
                        @if (intermediateResult.scaleMeasureDefinitions.length) {
                          <div>
                            {{getScaleDescription(progress?.progressValue)}}
                          </div>
                        }
                        @if (progress.attributionLevel) {
                          <div class="attribution">
                            <span>{{progress.attributionLevel.name}}</span>
                          </div>
                        }
                        <div class="attribution-text">
                          {{progress?.attributionDescription}}
                        </div>
                        @if (isStrategy) {
                          <div class="mt-1">
                            <a class="badge-primary badge font-size-lg"
                            [routerLink]="'/portfolio/' + progress.childProjectId">{{progress.childProjectName}}</a>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                  @if (progress.isStart) {
                    <tr>
                      <td class="text-right">
                        <div class="hub-unique-id-panel">
                          <span class="hub-unique-id">{{progress.uniqueId}}</span>
                        </div>
                      </td>
                      <td class="text-right">
                        <span class="date-label text-primary">Start</span>
                      </td>
                      <td class="text-right">
                        <span class="d-block">
                          {{progress?.progressDate | date}}
                        </span>
                      </td>
                      <td class="text-right">
                        @if (intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{getScaleLabel(progress?.progressValue)}}
                          </span>
                        }
                        @if (!intermediateResult.scaleMeasureDefinitions.length) {
                          <span class="value">
                            {{progress?.progressValue | number:'':'en-US'}}
                          </span>
                        }
                        <span class="unit">
                          {{intermediateResult.unit}}
                        </span>
                        @if (intermediateResult.scaleMeasureDefinitions.length) {
                          <div>
                            {{getScaleDescription(progress?.progressValue)}}
                          </div>
                        }
                        @if (progress.attributionLevel) {
                          <div class="attribution">
                            <span>{{progress.attributionLevel.name}}</span>
                          </div>
                        }
                        <div class="attribution-text">
                          {{progress?.attributionDescription}}
                        </div>
                        @if (isStrategy) {
                          <div class="mt-1">
                            <a class="badge-primary badge font-size-lg"
                            [routerLink]="'/portfolio/' + progress.childProjectId">{{progress.childProjectName}}</a>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
        </div>
      }
      @if (detailsLoading) {
        <app-modal-spinner></app-modal-spinner>
      }
    </div>
  }
</div>
}